<template>
    <v-dialog v-model="dialogProp" width="500">
        <v-card>
            <v-toolbar flat>
                <v-spacer />
                <v-btn icon @click="dialogProp = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-title>
                <h4 style="word-break: break-word;">
                    Annual Check-up (ACU):
                </h4>
                <h6 style="word-break: break-word;">
                    An Annual Check-up (ACU) is a suite of services recommended to
                    evaluate your state-of-health. The APE consists of the following:
                </h6>
            </v-card-title>
            <v-divider />

            <v-card-text>
                <ul v-for="(acus, i) in acuss" :key="i">
                    <li>{{ acus }}</li>
                </ul>
                <div class="closing">
                    These services are to be done at HMICare Clinic & Diagnostic Center
                    or at the MSU designated by the HMI Hospital Operations Department,
                    once the member has completed one (1) year of payment (annual
                    payment mode) or one (1) year of continuous membership.
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
    props: ['showAnnualCheckup'],

    data: () => ({
        mdiClose,
        acuss: [
            'Physical Examination',
            'Chest X-Ray',
            'Urinalysis',
            'Stool Exam (Fecalysis)',
            'Complete Blood Count (CBC)',
            'Electrocardiogram (ECG) for members 35 years old and 	above or as requested by an HMI accredited Specialist.',
            'Pap Smear for female members 35 years old and above or 	as requested by an HMI accredited Specialist.'
        ]
    }),
    computed: {
        dialogProp: {
            get() {
                return this.showAnnualCheckup
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    }
}
</script>

<style scoped>
.closing {
    color: black;
    padding: 10px 0;
}
ul li {
  font-size: 13px;
  padding-top: 10px;
  color: black;
}
h6 {
  font-weight: normal;
  font-size: 15px;
  color: black;
  line-height: 1.5em;
  width: 100%;
  padding: 0px 10px;
  margin: auto;
}
@media (max-width: 599px) {
  h6 {
    padding: 0px;
    line-height: 1.2em;
    font-size: 12.5px;
  }
}
</style>
